<template>
    <cgs-modal v-model:visible="vis" title="设置部门标签" @close="close" :width="500">
        <div style="height: 100px;">
            <div style="color: red;" v-if="!canEditDept">选择此选项时，部门树不可进行编辑删除操作！</div>
            <div class="set-department-label-item">
                <span>选择范围：</span>
                <cgs-cascader @change="state.editDept = false" v-model:value="state.currentType" style="width: 350px;"
                    :options="options" placeholder="请选择"></cgs-cascader>
            </div>
            <template v-if="state.currentType">
                <div class="set-department-label-item"
                    v-if="state.currentType[0] === '1' && state.currentType[1] !== '1-1'">
                    <span>选择部门：</span>
                    <!-- multiple -->
                    <cgs-cascader v-model:value="state.userDepts" style="width: 350px;" change-on-select
                        :options="state.dept_options" placeholder="请选择"
                        :fieldNames="{ label: 'name', value: 'id', children: 'children' }" />
                </div>
                <div class="set-department-label-item" v-if="state.currentType[0] === '2'">
                    <span>选择标签：</span>
                    <cgs-select v-model:value="state.labels" mode="tags" style="width: 350px;">
                        <cgs-select-option :value="tag.id" :key="tag.id" v-for="tag in state.deptLabelList">{{ tag.name
                            }}</cgs-select-option>
                    </cgs-select>
                </div>
                <div class="set-department-label-item" v-if="canEditDept">
                    <span>部门编辑：</span>
                    <cgs-switch v-model:checked="state.editDept" checkedChildren="可编辑" unCheckedChildren="不可编辑" />
                </div>
            </template>
        </div>
        <template #footer>
            <div class="portal-public-select-user-modal-footer">
                <cgs-button @click="close">{{ $t('common.cancel') }}</cgs-button>
                <cgs-button type="primary" @click="ok">{{ $t('common.ok') }}</cgs-button>
            </div>
        </template>
    </cgs-modal>
</template>

<script setup>
import { watch, computed, defineProps, onMounted, onUnmounted, reactive } from "vue";
import {
    getDepartmentList
} from '@api/user'
import {
    getDeptLabelList,
} from "@/api/tenant";
import {
    getRoleInfo,
} from '@api/scene'

const emit = defineEmits(['close', 'ok'])
const props = defineProps({
    visible: Boolean,
    roleId: String,
    sceneType: String,
})
const state = reactive({
    currentType: ['2', '2-5'],
    userDepts: "",
    dept_options: [],
    deptList: [],
    deptLabelList: [],
    labels: [],
    editDept: false
})
const canEditDept = computed(() => {
    if (!state.currentType) return false
    if (state.currentType[0] === '1') return false
    if (state.currentType[0] === '2') {
        if (state.currentType[1] !== '2-4' && state.currentType[1] !== '2-5') {
            return false
        }
    }
    return true
})
const ok = () => {
    let data = {
        "type": state.currentType,
        "editDept": state.editDept,
        "params": []
    }
    if (state.currentType) {
        if (state.currentType[0] === "1") {
            if (state.currentType[1] !== "1-1") {
                data.params = [state.userDepts[state.userDepts.length - 1]]
                // data.params = [state.userDepts[state.userDepts.length - 1]]
            }
        } else {
            data.params = state.labels
        }
    }
    emit('ok', data)
}
// onMounted(() => {
//     _init()
// })
const _init = async () => {
    try {
        let _departmentResult = await getDepartmentList()
        if (_departmentResult.code === 200) {
            state.deptList = _departmentResult.data
            state.dept_options = createDeptTree(_departmentResult.data)
        }
        let _labelRes = await getDeptLabelList()
        if (_labelRes.code === 200) {
            state.deptLabelList = _labelRes.data;
        }
    } catch (err) {
        console.error(err)
    }
}

watch(() => props.visible, async (newVal) => {
    if (newVal) {
        await _init()
        let _roleInfoParams = {
            id: props.roleId,
            visualType: props.sceneType,
        }
        let _roleInfoResult = await getRoleInfo(_roleInfoParams)
        if (_roleInfoResult.code === 200) {
            if (_roleInfoResult.data?.deptAndUserAuths) {
                let { type, params, editDept } = _roleInfoResult.data?.deptAndUserAuths
                state.currentType = type
                state.editDept = editDept
                if (type[0] === '1') {
                    if (type[1] !== "1-1") {
                        let arr = []
                        findParentWay(state.deptList, params[0], arr)
                        state.userDepts = arr
                    }
                } else if (type[0] === '2') {
                    state.labels = params
                }
            }
        }
    }
})
const findParentWay = (deptList = [], id, arr) => {
    var m = {};
    deptList.forEach(d => {
        m[d.id] = d
    });
    setChild(id, arr, m)
}
const setChild = (id, arr, obj) => {
    if (id === "0") return
    arr.unshift(id)
    setChild(obj[id].parentId, arr, obj)
}
const createDeptTree = (deptList = []) => {
    var m = {};
    deptList.forEach(d => {
        var pId = d.parentId
        if (!m[pId]) {
            m[pId] = []
        }
        m[pId].push(d)
    });
    var pArr = m["0"]
    var tree = []
    if (!pArr) return tree;
    pArr.forEach(p => {
        var dept = {
            ...p,
            property: p.property ? p.property : {},
            children: getChildren(p, m)
        }
        tree.push(dept)
    })
    return tree;

}
const getChildren = (p, m) => {
    var id = p.id
    var childs = m[id];
    if (!childs) return [];
    var children = []
    childs.forEach(c => {
        var d = {
            ...c,
            property: c.property ? c.property : {},
            children: getChildren(c, m)
        }
        children.push(d)

    })

    return children;
}
onUnmounted(() => { })

const options = [
    {
        value: "1",
        label: "部门",
        children: [
            {
                value: "1-1",
                label: "全组织",
            },
            {
                value: "1-2",
                label: "指定部门",
            },
            {
                value: "1-3",
                label: "指定部门和所有下级部门",
            },
            {
                value: "1-4",
                label: "仅指定部门的所有下级部门",
            },
        ],
    },
    {
        value: "2",
        label: "标签",
        children: [
            {
                value: "2-1",
                label: "指定部门标签",
            },
            {
                value: "2-2",
                label: "指定部门标签和所有下级部门",
            },
            {
                value: "2-3",
                label: "仅指定部门标签的所有下级部门",
            },
            {
                value: "2-4",
                label: "当前用户所在...标签部门",
                editTree: true
            },
            {
                value: "2-5",
                label: "当前用户所在...标签部门和所有下级部门",
                editTree: true
            },
            {
                value: "2-6",
                label: "仅当前用户所在...标签部门的所有下级部门",
            },
        ],
    },
];
const vis = computed({
    get: () => {
        return props.visible
    },
    set: (val) => {
        emit('update:visible', val)
    }
})

const close = () => {
    emit('close')
    vis.value = false
}
</script>

<style scoped>
.set-department-label-item {
    padding: 5px 0;
    display: flex;
    align-items: center;
}
</style>